export interface ValidationRequest {
    image: string; // base64 encoded image
    filename: string;
    country?: string; // ISO 3166-1 alpha-2 country code
    docType?: 'passport' | 'drivers_license';
}

export interface ValidationResponse {
    success: boolean;
    status: 'COMPLIANT' | 'REJECTED';
    reason_code: string;
    details?: {
        validator_reason_code?: string;
        validator_reason_description?: string;
        error?: string;
    };
    orderId?: string; // UUID of the stored order
    imageUrl?: string; // Signed URL to access the validated image
    sheetUrl?: string; // Signed URL to access the print sheet image
    error?: string; // Error message if validation failed or storage failed
}

export interface RemoveBackgroundRequest {
    orderId: string;
}

export interface RemoveBackgroundResponse {
    success: boolean;
    orderId?: string;
    imageUrl?: string;
    sheetUrl?: string;
    error?: string;
}

// --- Order Management ---

export interface ShippingInfo {
    first_name: string
    last_name: string
    address_1: string
    address_2?: string
    city: string
    postal_or_zip_code: string
    state?: string
    country_code: string
    email?: string
    phone?: string
}

export interface Order {
    id: string
    status: string
    familinkId?: string
    shipping?: ShippingInfo
    stripePaymentIntentId?: string
    stripeSessionId?: string
    createdAt: string
    updatedAt: string
    rejectionReason?: string
    imageUrl?: string | null
}

export interface OrdersResponse {
    success: boolean
    orders: Order[]
    error?: string
}

export interface OrderActionResponse {
    success: boolean
    message?: string
    error?: string
}

export const REJECTION_REASONS = [
    'Background incorrect or not uniform',
    'Face too small or poorly positioned',
    'Eyes not visible or closed',
    'Poor lighting or shadows on face',
    'Glasses with glare or tinted lenses',
    'Head covering obscuring face',
    'Image quality too low',
    'Non neutral expression (smiling, frowning, etc.)',
    'Other violation'
] as const 